module.exports = __webpack_public_path__ + "img/6579948.jpg";